import { defineAction } from '~/prix'
import { z } from 'zod'
import llmTemplateExtractAction from './llmTemplateExtract.action.json' with { type: 'json' }

const llmTemplateExtractDefinition = defineAction({
  ...llmTemplateExtractAction,

  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    stats: z.object({
      processedTablesAndColumns: z.number(),
      processedVariables: z.number(),
      totalTokens: z.number(),
      totalCost: z.number(),
    }),
  }),
})

export default llmTemplateExtractDefinition
